import { render } from "./Security_ChangePassword_Dialog.vue?vue&type=template&id=f4662944&scoped=true&ts=true"
import script from "./Security_ChangePassword_Dialog.vue?vue&type=script&lang=ts"
export * from "./Security_ChangePassword_Dialog.vue?vue&type=script&lang=ts"

import "./Security_ChangePassword_Dialog.vue?vue&type=style&index=0&id=f4662944&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4662944"]])

export default __exports__